import {styled} from "@mui/material";
import {Close} from "@mui/icons-material";
import React from "react";
import Box from "@mui/material/Box";
import isEmpty from "lodash/isEmpty";

interface TagProps {
    label: string;
    index: number
    maxWidth?: string
    onDelete?: (event: any) => void;
}

function Tag(props: TagProps) {
    const {label, onDelete, index, ...other} = props;
    return (
        <Box component={'div'} key={index}  {...other}>
            <span>{label}</span>
            {onDelete && <Close onClick={(event) => {
                event.preventDefault()
                onDelete!(index)
            }}/>}
        </Box>
    );
}

export const TagOut = styled(Tag)<TagProps>(({theme, onDelete, maxWidth = '60px'}) => ({
    display: 'flex',
    alignItems: 'center',
    height: '22px',
    margin: 1,
    lineHeight: '22px',
    backgroundColor: '#fafafa',
    border: `1px solid #e8e8e8`,
    borderRadius: '2px',
    boxSizing: 'content-box',
    padding: `0 4px 0 ${!isEmpty(onDelete) ? '10px' : "4px"}`,
    outline: 0,
    overflow: 'hidden',
    ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255,255,255,0.08)',
        borderColor: '#303030',
    }),
    '&:focus': {
        borderColor: '#40a9ff',
        backgroundColor: '#e6f7ff',
        ...theme.applyStyles('dark', {
            backgroundColor: '#003b57',
            borderColor: '#177ddc',
        }),
    },
    '& span': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: maxWidth,
        fontSize: '12px'
    },
    '& svg': {
        fontSize: '12px',
        cursor: 'pointer',
        padding: '4px',
    },
}));
